<template>
  <div>
    <slot name="errorText" v-if="showErrorText"></slot>
    <slot name="successText" v-if="showSuccessMessage && showSuccessText"></slot>
    <div class="downloadText" v-if="!automaticDownload">
      <slot name="txtBeforeLink"></slot>
      <a @click.prevent="download()"><slot name="downloadLink"></slot></a>
      <slot name="txtAfterLink"></slot>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import urlParam from '@/mixins/urlParam'
import FileSaver from 'file-saver'
import transaction from '@/mixins/transaction'
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadContractSummary',
  data () {
    return {
      token: null,
      brand: null,
      showErrorText: false,
      showSuccessText: false
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    showSuccessMessage () {
      return this.showSuccess
    }
  },
  methods: {
    download () {
      const me = this
      const baseUrl = '/api/document/external-order-contract-summary/'

      axios.get(baseUrl + this.brand + '/' + this.token, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'vertragszusammenfassung.pdf')
        this.showErrorText = false
        this.showSuccessText = true
      }).catch((reason) => {
        this.showErrorText = true
        this.showSuccessText = false
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  created () {
    this.brand = this.$store.getters.brand
  },
  mounted () {
    this.token = this.getURLParam('docManCsToken')
    if (this.token === null || this.token === '') {
      this.showErrorText = true
    } else {
      this.showErrorText = false
      if (this.automaticDownload) {
        this.download()
      }
    }
  },
  mixins: [
    transaction('contractSummary'), urlParam
  ],
  props: {
    automaticDownload: {
      type: Boolean,
      default: true
    },
    showSuccess: {
      type: Boolean,
      default: true
    }
  }
}
</script>
